import React, { ComponentType, useState } from 'react';
import * as Sentry from '@sentry/react';
import { useHistory } from 'react-router-dom';
import PlanningRoom from './PlanningRoom';
import RoomCrashFallback from './RoomCrashFallback';

interface PlanningRoomBoundaryProps {
  RoomComponent?: ComponentType;
  roomId: string;
}

const PlanningRoomBoundary = ({
  RoomComponent = PlanningRoom,
  roomId,
}: PlanningRoomBoundaryProps) => {
  const history = useHistory();
  const [roomInstance, setRoomInstance] = useState(0);

  return (
    <Sentry.ErrorBoundary
      beforeCapture={scope => scope.setTag('boundary', 'planning-room')}
      fallback={({ resetError }) => (
        <RoomCrashFallback
          onRejoin={() => {
            setRoomInstance(instance => instance + 1);
            resetError();
          }}
          onLeave={() => {
            resetError();
            history.push('/');
          }}
        />
      )}>
      <RoomComponent key={`${roomId}-${roomInstance}`} />
    </Sentry.ErrorBoundary>
  );
};

export default PlanningRoomBoundary;
